import { render, staticRenderFns } from "./Poi.vue?vue&type=template&id=2437a924"
import script from "./Poi.vue?vue&type=script&lang=js"
export * from "./Poi.vue?vue&type=script&lang=js"
import style0 from "./Poi.vue?vue&type=style&index=0&id=2437a924&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports